import * as React from 'react';
import { styled } from '@linaria/react';

import OpacityLabel from './OpacityLabel';
import { useTrackedOpacity } from './PartialKeyframes.helpers';

interface Props {
  targetOpacity: number;
  isToggled: boolean;
}

function Ball({ targetOpacity, isToggled }: Props) {
  const buttonRef = React.useRef<HTMLDivElement>(null);
  const displayedOpacity = useTrackedOpacity(
    targetOpacity,
    buttonRef,
    isToggled
  );

  return (
    <Wrapper data-is-toggled={isToggled}>
      <OpacityLabel opacity={displayedOpacity} />
      <BallWrapper>
        <BallSocket />
        {isToggled && (
          <BallElem
            ref={buttonRef}
            style={{ opacity: targetOpacity ?? 0 }}
          />
        )}
      </BallWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const BallWrapper = styled.div`
  position: relative;
`;

const BallSocket = styled.div`
  --size: 64px;
  position: relative;
  width: var(--size);
  height: var(--size);
  border: 2px solid var(--color-gray-300);
  border-radius: 45%;
  background: url('/images/partial-keyframes/transparent-white-16x16-10p.png')
    repeat;
`;

const BallElem = styled.div`
  position: absolute;
  inset: 0;
  background: hsl(50deg 100% 50%);
  border-radius: 45%;

  ${Wrapper}[data-is-toggled='true'] & {
    animation: fadeFromTransparent 1000ms;
  }
`;

export default Ball;
